import { createSelector } from "reselect";

import { DrilldownSlice } from "@sportal/api/reports";
import { RootState } from "../../../root.reducer";
import { getReports } from "../../../root.selectors";
import { TableSlice } from "../../reports.types";
import { DrilldownDataKeys } from "../../../../helpers/reports.helper.types";

export const getTable = (state: RootState): TableSlice =>
  getReports(state).table;

export const getTableData = (table: DrilldownDataKeys) =>
  createSelector(
    [getTable],
    (tableSlice: TableSlice): DrilldownSlice[] => tableSlice[table].data
  );

export const isTableLoading = (table: DrilldownDataKeys) =>
  createSelector(
    [getTable],
    (tableSlice: TableSlice): boolean => tableSlice[table].isLoading
  );

export const isTableLoadFailed = (table: DrilldownDataKeys) =>
  createSelector(
    [getTable],
    (tableSlice: TableSlice): boolean => !!tableSlice[table].error
  );
